export interface Meeting {
  id: string
  zoomId: string
  url: string

  title: string
  startTime: string

  transcript: string | null
  summary: string | null
  assistContext: MeetingAssistContext | null
  metadata: Record<string, any> | null
  participants: MeetingParticipant[] | null
  botStatus: MeetingBotStatus
}

export const enum MeetingAssistType {
  Question = 'question',
  Objection = 'objection',
  NextStep = 'next_step',
  Insight = 'insight',
  Tip = 'tip',
}

export enum MeetingAssistMode {
  Team = 'team',
  Sales = 'sales',
  Teaching = 'teaching',
  Presentation = 'presentation',
  Interview = 'interview',
  Standup = 'standup',
  Casual = 'casual',
  Facilitator = 'facilitator',
  Consultation = 'consultation',
}

export enum MeetingAssistAudienceLevel {
  Beginner = 'beginner',
  Intermediate = 'intermediate',
  Advanced = 'advanced',
  Executive = 'executive',
  Mixed = 'mixed',
}

export enum MeetingAssistPhase {
  Opening = 'opening',
  Discovery = 'discovery',
  Delivery = 'delivery',
  Objections = 'objections',
  Decision = 'decision',
  Closing = 'closing',
}

export interface MeetingAssistDocument {
  id: string
  name: string
  mimeType: string
  size: number
  text: string
  createdAt: string
}

export interface MeetingAssistSeriesContext {
  meetingId: string
  title?: string
  summary?: string
  reason?: string
  confidence?: number
  lastMeetingAt?: string
  generatedAt?: string
}

export interface MeetingAssistContext {
  mode?: MeetingAssistMode
  brief?: string
  goal?: string
  agenda?: string
  audienceLevel?: MeetingAssistAudienceLevel
  phase?: MeetingAssistPhase
  priorityTopics?: string[]
  phases?: string[]
  keyQuestions?: string[]
  successOutcome?: string
  structureGeneratedAt?: string
  seriesContext?: MeetingAssistSeriesContext
  documents?: MeetingAssistDocument[]
}

export enum MeetingAssistFeedbackValue {
  Up = 'up',
  Down = 'down',
}

export interface MeetingAssistCue {
  id: string
  type: MeetingAssistType
  text: string
  priority: number
  createdAt: string
}

export const enum MeetingParticipantStatus {
  RequestedEmail = 'requested_email',
  LoadingInfo = 'loading_info',
  Idle = 'idle',
  Error = 'error',
}

export interface MeetingParticipant {
  participantUUID: string
  screenName: string
  status: MeetingParticipantStatus
  leftMeeting: boolean
  role?: string
  participantEmail?: string
  errorMessage?: string
  timestamp: number
  linkedInInfo?: MeetingParticipantProxyData
}

interface MeetingParticipantProxyData {
  person: any // TODO: types?
  company?: any // TODO: types?
}

export const enum MeetingBotStatus {
  Inactive = 'inactive', // bot is not defined or already stopped by user
  BotJoining = 'bot-joining', // bot is joining the meeting, command received
  Waiting = 'waiting', // bot is in the meeting, but not recording yet
  Recording = 'recording', // bot is recording the meeting
  BotLeaving = 'bot-leaving', // call ended, or bot is leaving by user request
  Error = 'error', // bot encountered an error while joining, starting to record, or leaving
}
